var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { siteX } from "../interceptors/api";
export const apReportsApi = {
    getApReports: (apUid_1, ...args_1) => __awaiter(void 0, [apUid_1, ...args_1], void 0, function* (apUid, pageNumber = 1, pageSize = 20) {
        const queryParams = new URLSearchParams();
        queryParams.append("apUid", apUid);
        queryParams.append("pageNumber", pageNumber.toString());
        queryParams.append("pageSize", pageSize.toString());
        const response = yield siteX.get(`ap-reports?${queryParams.toString()}`);
        return response.data;
    }),
    downloadApReport: (reportId) => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield siteX.get(`ap-reports/${reportId}/download`, {
            responseType: "blob",
        });
        return response.data;
    }),
};
